import { render, staticRenderFns } from "./AutoQuery.vue?vue&type=template&id=7dc33622&"
import script from "./AutoQuery.vue?vue&type=script&lang=js&"
export * from "./AutoQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports